import {
  EnvironmentProviders,
  ErrorHandler,
  inject,
  provideAppInitializer,
  Provider,
} from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

export function provideSentry(): Provider | EnvironmentProviders[] {
  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ];
}
